export const HOME_HEALTH_CASES_PATH = "home-health/cases";
